module.exports = __webpack_public_path__ + "img/icon-arrow.ef697af6.svg";